import React from 'react';
import { TestResultSvbPvb } from '@ecosconnect/core/src/types/jobFormData';
import AccordionItem from '../../../Accordion/AccordionItem';
import { formatDecimal } from '@ecosconnect/core/src/helpers/number';

const SvbPvbTestResult: React.FC<{ test: TestResultSvbPvb }> = ({ test }) => {
  return (
    <>
      <AccordionItem
        label="Air Inlet Opened At"
        kind={test.didNotOpen ? 'chip' : 'text'}
        status={test.didNotOpen ? 'error' : 'default'}
        value={
          test.didNotOpen ? 'Did not fully open' : formatDecimal(test.openedAt)
        }
      />
      <AccordionItem
        label="Check Valve"
        value={formatDecimal(test.pressureDrop)}
      />
    </>
  );
};

export default SvbPvbTestResult;
